export default __webpack_public_path__ + "static/media/gallery-wip-handle_03.8dc84af9.jpg";